import { render } from "./AnswerPageOne.vue?vue&type=template&id=29d975da&scoped=true"
import script from "./AnswerPageOne.vue?vue&type=script&lang=js"
export * from "./AnswerPageOne.vue?vue&type=script&lang=js"

import "./AnswerPageOne.vue?vue&type=style&index=0&id=29d975da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d975da"]])

export default __exports__